import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import $ from 'jquery';

const FeedbackInsightsDashboard = ({ branches, handleSectionChange,setSelecteddashboardBranch,setselectedfeedbackdashboardBranch, businessId: propBusinessId

 }) => {
    const [insights, setInsights] = useState({
        branches: [],
        comments: [],
        popular_services: [],
        service_comments: [],
        qos_by_branch: [],
        experience_by_branch: [],
        value_by_branch: [],
    });
    const [loading, setLoading] = useState(true);
    const token = sessionStorage.getItem('token');
    const businessId = propBusinessId || JSON.parse(sessionStorage.getItem('userData'))?.businessId || JSON.parse(sessionStorage.getItem('userData'))?.selectedBusinessId
;
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedDate, setSelectedDate] = useState('');

    const getCurrentMonth = () => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        return `${year}-${month < 10 ? '0' : ''}${month}`;
    };

    const formatMonthInput = (dateStr) => {
        const parts = dateStr.split('-');
        const year = parts[0];
        const month = parts[1].padStart(2, '0');
        return `${year}-${month}`;
    };

    useEffect(() => {
        const fetchFeedbackInsights = async () => {
            try {
                setLoading(true);
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/fetchFeedbackInsights`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        businessId,
                        branch_id: selectedBranch,
                        date:selectedDate
                    }),
                });
                const result = await response.json();
                if (result.success) {
                    setInsights(result);
                }
            } catch (error) {
                console.error('Error fetching feedback insights:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchFeedbackInsights();
    }, [businessId, token, selectedBranch, selectedDate]);

    useEffect(() => {
        const $branchSelect = $('#branchSelect');
        $branchSelect.select2();
        $branchSelect.on('change', function () {
            setSelectedBranch($(this).val());
        });

        return () => {
            $branchSelect.select2('destroy');
        };
    }, []);

     const formatRatingValue = (value) => {
        const num = parseFloat(value);
        return num % 1 === 0 ? num.toFixed(0) : num.toFixed(1);
    };


    const createRatingChart = (title, categories, seriesData, colors) => ({
        chart: {
            type: 'column',
            height: '300px'
        },
        title: { text: title },
        xAxis: { categories },
        yAxis: {
            title: { text: 'Average Feedback' },
            min: 0,
            max: 5
        },
        colors,
        series: [{
            name: "Branch's",
            data: seriesData.map((val, i) => ({
                name: categories[i], // branch name
                y: parseFloat(formatRatingValue(val))
            })),
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return formatRatingValue(this.y);
                }
            }
        }],
        tooltip: {
            formatter: function () {
                return `<b>${this.point.name}</b><br/>Average Feedback: <b>${formatRatingValue(this.y)}</b>`;
            }
        }
    });


     const handleInvoiceClick = (branchId) => {
        // Optionally, you can pass the branchId to fetch specific invoices
        console.log('branch is for section change',branchId);
        setSelecteddashboardBranch(branchId);  // This could be used to filter the invoices by branch
        handleSectionChange('sale-invoices');
        //  setActiveSection('sale-invoices');
        };

    const handlefeedbacksClick = (branchId) => {
        // console.log("Clicked reviews for branch:", branchId);
        setselectedfeedbackdashboardBranch(branchId);  // This could be used to filter the invoices by branch
        handleSectionChange('feedbacks');
    };

   

    return (
        <div className="feedback-insights-container container-fluid mt-4">
            
            {/* Filter Section */}
            <div className='row align-items-end mb-3'>
                <div className='col-md-8'></div>
                <div className='col-md-2'>
                    <div className="form-group">
                        <label>Select Branch</label>
                        <select id='branchSelect' className='form-control' value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
                            <option value='0'>All</option>
                            {Array.isArray(branches) && branches.length > 0 ? (
                                branches.map((branch) => (
                                    <option key={branch.id_branch} value={branch.id_branch}>
                                        {branch.branch_name}
                                    </option>
                                ))
                            ) : (
                                <option disabled>No branches available</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className='col-md-2'>
                    <div className="form-group">
                        <label>Select Date</label>
                        <input
                            type='month'
                            className='form-control'
                            value={selectedDate || getCurrentMonth()}
                            onChange={(e) => setSelectedDate(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                 <section className="dashboard-charts">
                                <h2 style={{ textAlign: 'center', marginTop: '40px', color: '#2c3e50' }}>
                                    📊 Branches Statistics
                                </h2>
                                <div style={{ padding: '20px' }}>
                                {insights.branch_invoice_stats && insights.branch_invoice_stats.length > 0 ? (
                                    <table id='statistics-table'
                                        style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            marginTop: '20px'
                                        }}
                                    >
                                        <thead style={{ backgroundColor: '#f4f6f9' }}>
                                            <tr>
                                                <th style={{ padding: '12px', textAlign: 'left' }}>Branch</th>
                                                <th style={{ padding: '12px', textAlign: 'right' }}>Total Sales</th>
                                                <th style={{ padding: '12px', textAlign: 'right' }}>Invoices</th>
                                                <th style={{ padding: '12px', textAlign: 'right' }}>Feedbacks</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ maxHeight: '200px', overflowY: 'auto', width: '100%' }}>
                                            {insights.branch_invoice_stats.map((branch, index) => (
                                                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                                    <td style={{ padding: '12px', fontWeight: 500 }}>
                                                        <div style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center',
                                                            fontWeight:'bold',
                                                            cursor: 'pointer', 
                                                            textDecoration: 'underline', 
                                                            color: '#88a585'
                                                        }} onClick={() => handleInvoiceClick(branch.branch_id)}>
                                                            {branch.branch_name}
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '12px', textAlign: 'right' }}>
                                                        {branch.total_sales ? `${parseFloat(branch.total_sales).toLocaleString()}` : "$0"}
                                                    </td>
                                                    <td style={{ 
                                                        fontWeight:'bold',
                                                        padding: '12px', 
                                                        textAlign: 'right', 
                                                        cursor: 'pointer', 
                                                        textDecoration: 'underline', 
                                                        color: '#88a585'
                                                    }} onClick={() => handleInvoiceClick(branch.branch_id)}>
                                                        {branch.count_of_invoices > 0 ? branch.count_of_invoices : "0"}
                                                    </td>
                                                    <td style={{ 
                                                        fontWeight:'bold',
                                                        padding: '12px', 
                                                        textAlign: 'right', 
                                                        cursor: 'pointer', 
                                                        textDecoration: 'underline', 
                                                        color: '#88a585'
                                                    }} onClick={() => handlefeedbacksClick(branch.branch_id)}>
                                                        {branch.count_of_reviews > 0 ? branch.count_of_reviews : "0"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p>No branch data available</p>
                                )}

                                </div>
                            </section>
                    {/* Individual Charts */}
                <div className="row mb-4">
                <div className="col-md-6">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={createRatingChart(
                            'Quality of Service by Branch',
                            insights.qos_by_branch?.map(b => b.branch_name) || [],
                            insights.qos_by_branch?.map(b => parseFloat(b.avg_qos)) || [],
                            ['#2f7ed8']
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={createRatingChart(
                            'Customer Experience by Branch',
                            insights.experience_by_branch?.map(b => b.branch_name) || [],
                            insights.experience_by_branch?.map(b => parseFloat(b.avg_experience)) || [],
                            ['#8bbc21']
                        )}
                    />
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-md-6">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={createRatingChart(
                            'Value for Money by Branch',
                            insights.value_by_branch?.map(b => b.branch_name) || [],
                            insights.value_by_branch?.map(b => parseFloat(b.avg_value)) || [],
                            ['#f28f43']
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={createRatingChart(
                            'Atmosphere by Branch',
                            insights.atmosphere_by_branch?.map(b => b.branch_name) || [],
                            insights.atmosphere_by_branch?.map(b => parseFloat(b.avg_atmosphere)) || [],
                            ['#434348']
                        )}
                    />
                </div>
            </div>

            <div className="row mb-4">
                {/* Increase this column size to 12 for full width on the last chart */}
                <div className="col-md-12">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={createRatingChart(
                            'Recommendability by Branch',
                            insights.recommendable_by_branch?.map(b => b.branch_name) || [],
                            insights.recommendable_by_branch?.map(b => parseFloat(b.avg_recommendable)) || [],
                            ['#7cb5ec']
                        )}
                    />
                </div>
            </div>


                </>
            )}
        </div>
    );
};

export default FeedbackInsightsDashboard;
